<template>

</template>

<script>
import Common from 'common/js/common'
export default {
  data() {
    return {
    }
  },
  created() {
    this.getPar()
  },
  methods: {
    getPar() {
      // loginType = 1 营业数据按钮，loginTpye = 2昨日推送消息 ，loginType = 3,支付的推送消息
      const loginType = Common.getUrlParam('loginType')
      if (loginType === '1') { // 微信公众号底部 的营业数据按钮,去授权
        const code = Common.getUrlParam('code')
        const local = window.location.href
        if (code == null || code === '') {
          const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Common.Appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
          
          window.location.href = url
        } else {
          const loginType = Common.getUrlParam('loginType')
          this.getAxiosData(code, loginType)
        }
        return
      }
      if (loginType === '2') { // 昨日数据推送消息，进入 首页，时间选择器默认为昨日,缓存openId，userId和merchantId
        const openId = Common.getUrlParam('openId')
        this.common.localSet('openId', openId)
        const userId = Common.getUrlParam('userId')
        const merchantId = Common.getUrlParam('merchantId')
        const loginInfo = {}
        loginInfo.userId = userId
        loginInfo.merchantId = merchantId
        this.common.localSet('loginInfo', loginInfo)
        this.common.localSet('dayFlag', 1) // 昨日数据标记
        this.$router.push({ path: '/dataDisplay' }) // 跳转到首页，昨日数据
        return
      }
      if (loginType === '3') { // 支付数据推送消息，进入已收款订单列表页,缓存openId，userId和merchantId
        const openId = Common.getUrlParam('openId')
        this.common.localSet('openId', openId)
        const userId = Common.getUrlParam('userId')
        const merchantId = Common.getUrlParam('merchantId')
        const loginInfo = {}
        loginInfo.userId = userId
        loginInfo.merchantId = merchantId
        this.common.localSet('loginInfo', loginInfo)
        this.common.localSet('dayFlag', 0) // 昨日数据标记
        this.$router.push({ path: '/orderList' })// 跳转到已收款订单列表页
        return
      }
    },
    getAxiosData(code) { // 获取openID
      const _this = this
      this.$http.get(Common.url_openId + '/findManagerOpenIdInfo', {
        params: {
          code: code
        }
      })
      .then(function(response) {
        console.log('code' + code)
        console.log('openID' + JSON.stringify(response))
        if (response.data.code === 0) {
          Common.localSet('openId', response.data.data.openid) // 缓存 openId
          _this.searchOpenId(response.data.data.openid)
        } else {
          console.log(response.data.msg)
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    searchOpenId(openId) { // 判断该openId是否有权限登录旗鱼算账宝，如有有直接跳到数据首页，没有的话到登录页
      const _this = this
      this.$http.get(Common.url_user + '/searchManagerH5Index', {
        params: {
          openId: openId
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          console.log(JSON.stringify(response))
          _this.common.localSet('dayFlag', 0) // 今日数据标记
          Common.localSet('loginInfo', response.data.data) // 缓存 urerId和merchantId
          _this.$router.push({ path: '/dataDisplay' }) // 有权限跳转到首页
        } else {
          _this.common.localSet('dayFlag', 0) // 今日数据标记
          _this.$router.push({ path: '/login' }) // 没有权限，跳转到登录页
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/author.vue